import React from "react";

const PoSvg = ({ fill = "#7065E4", width = "14px", height = "14px" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 13 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.45664 2.54109L9.36613 3.98835L11.5535 4.09172V0.547431C11.5535 0.370217 11.4177 0.222538 11.2367 0.20777L7.91794 0.00101974C7.73692 -0.0137481 7.57098 0.133931 7.5559 0.311145L7.48047 1.35966L8.41576 1.40397C9.01917 1.4335 9.48681 1.95038 9.45664 2.54109Z"
        fill={fill}
      />
      <path
        d="M8.61225 3.94171L8.68767 2.49446C8.70276 2.30248 8.55191 2.1548 8.37088 2.14003L7.43559 2.09573L5.32365 1.97758C5.14263 1.96281 4.97669 2.11049 4.96161 2.28771L4.87109 3.74973L7.31491 3.86787L8.61225 3.94171Z"
        fill={fill}
      />
      <path
        d="M12.913 5.03407C12.8376 4.9307 12.7169 4.87163 12.5962 4.87163L3.33385 4.41382L3.0774 2.75982C3.04723 2.55307 2.85112 2.39062 2.63993 2.39062H0.437474C0.196109 2.39062 0 2.58261 0 2.81889C0 3.05518 0.196109 3.24716 0.437474 3.24716H2.23262L3.40928 10.8378C3.46962 11.1923 3.63556 11.4876 3.86184 11.7239C3.60539 11.9602 3.45453 12.2999 3.45453 12.6691C3.45453 13.4075 4.07303 13.9982 4.81221 13.9982C5.55139 13.9982 6.16988 13.3927 6.16988 12.6691C6.16988 12.5066 6.13971 12.3442 6.07937 12.1965H9.26237C9.20203 12.3442 9.17186 12.5066 9.17186 12.6691C9.17186 13.4075 9.79035 13.9982 10.5295 13.9982C11.2838 13.9982 11.8872 13.3927 11.8872 12.6691C11.8872 11.9307 11.2687 11.34 10.5295 11.34H5.03849C4.66136 11.34 4.34456 11.0741 4.28422 10.7049L4.17863 10.0256H9.88087C11.1933 10.0256 12.3247 9.11001 12.551 7.8252L12.9884 5.37374C13.0186 5.27036 12.9884 5.13745 12.913 5.03407ZM4.82729 13.1416C4.55576 13.1416 4.34456 12.9349 4.34456 12.6691C4.34456 12.4032 4.55576 12.1965 4.82729 12.1965C5.09883 12.1965 5.31002 12.4032 5.31002 12.6691C5.31002 12.9349 5.08374 13.1416 4.82729 13.1416ZM11.0424 12.6838C11.0424 12.9497 10.8312 13.1564 10.5597 13.1564C10.2882 13.1564 10.077 12.9497 10.077 12.6838C10.077 12.418 10.2882 12.2113 10.5597 12.2113C10.8162 12.2113 11.0424 12.418 11.0424 12.6838Z"
        fill={fill}
      />
    </svg>
  );
};

export default PoSvg;
